// Used for caching the list of templates

import $api from '@/services/api';

export default {
  namespaced: true,
  state: {
    list: [],
    loading: false,
  },
  getters: {
    getLoading: (state) => {
      return state.loading;
    },
    getTemplates: (state) => {
      return state.list;
    },
    getTemplate: (state) => (templateId) => {
      return state.list.find((template) => template.id === templateId) || null;
    },
  },
  mutations: {
    setTemplateList(state, val) {
      state.list = val;
    },
    setLoading(state, val) {
      state.loading = val;
    },
  },
  actions: {
    ensure({ state, dispatch }) {
      if (!state.list.length) {
        dispatch('fetch');
      }
    },
    // Load the templates from the API
    async fetch({ state, commit }) {
      if (state.loading) return;
      commit('setLoading', true);

      try {
        const templates = await $api.get('/v1/internal/templates');
        commit('setTemplateList', templates);
      } catch (err) {
        commit('setTemplateList', []);
      }
      commit('setLoading', false);
    },
  },
};
